/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputAdminElementRoom } from './OutputAdminElementRoom';
import {
    OutputAdminElementRoomFromJSON,
    OutputAdminElementRoomFromJSONTyped,
    OutputAdminElementRoomToJSON,
} from './OutputAdminElementRoom';

/**
 * 
 * @export
 * @interface OutputAdminElementSession
 */
export interface OutputAdminElementSession {
    /**
     * CaptureNone — true, якщо allow-list кімнат порожній: бот НЕ обробляє жодної кімнати,
     * доки адмін явно не додасть хоч одну (порожньо більше не означає "ловити все").
     * @type {boolean}
     * @memberof OutputAdminElementSession
     */
    captureNone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminElementSession
     */
    configured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminElementSession
     */
    connected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementSession
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementSession
     */
    homeserver?: string;
    /**
     * HomeserverPresets — варіанти для перемикача homeserver у UI.
     * @type {Array<string>}
     * @memberof OutputAdminElementSession
     */
    homeserverPresets?: Array<string>;
    /**
     * 
     * @type {Array<OutputAdminElementRoom>}
     * @memberof OutputAdminElementSession
     */
    rooms?: Array<OutputAdminElementRoom>;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminElementSession
     */
    updatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementSession
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementSession
     */
    verifiedAt?: string;
}

/**
 * Check if a given object implements the OutputAdminElementSession interface.
 */
export function instanceOfOutputAdminElementSession(value: object): boolean {
    return true;
}

export function OutputAdminElementSessionFromJSON(json: any): OutputAdminElementSession {
    return OutputAdminElementSessionFromJSONTyped(json, false);
}

export function OutputAdminElementSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminElementSession {
    if (json == null) {
        return json;
    }
    return {
        
        'captureNone': json['captureNone'] == null ? undefined : json['captureNone'],
        'configured': json['configured'] == null ? undefined : json['configured'],
        'connected': json['connected'] == null ? undefined : json['connected'],
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'homeserver': json['homeserver'] == null ? undefined : json['homeserver'],
        'homeserverPresets': json['homeserverPresets'] == null ? undefined : json['homeserverPresets'],
        'rooms': json['rooms'] == null ? undefined : ((json['rooms'] as Array<any>).map(OutputAdminElementRoomFromJSON)),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'verifiedAt': json['verifiedAt'] == null ? undefined : json['verifiedAt'],
    };
}

export function OutputAdminElementSessionToJSON(value?: OutputAdminElementSession | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'captureNone': value['captureNone'],
        'configured': value['configured'],
        'connected': value['connected'],
        'deviceId': value['deviceId'],
        'homeserver': value['homeserver'],
        'homeserverPresets': value['homeserverPresets'],
        'rooms': value['rooms'] == null ? undefined : ((value['rooms'] as Array<any>).map(OutputAdminElementRoomToJSON)),
        'updatedBy': value['updatedBy'],
        'userId': value['userId'],
        'verifiedAt': value['verifiedAt'],
    };
}

